import React, { useState } from 'react';
import RatingStar from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/RatingStar';

function SingleReview({ data, translateControl, replyControl }) {
    const [showOriginal, setShowOriginal] = useState(false);
    const [showOriginalReply, setShowOriginalReply] = useState(false);

    const handleToggle = () => {
        setShowOriginal((prev) => !prev);
    };
    const handleToggleReply = () => {
        setShowOriginalReply((prev) => !prev);
    };

    return (
        <div className="single-review__content-box d-flex flex-column">
            <div className="single-review__content-box-header d-flex justify-content-between">
                <div className="single-review__content-box-header__details d-flex flex-column">
                    <p className="single-review__content-box-header-author">{data.author}</p>
                </div>
                <div className="single-review__content-box-header-grades d-flex">
                    <div className="single-review__content-box-header-grade d-flex justify-content-center align-items-center flex-column">
                        <p>{data.gradeForAccommodation}</p>
                        <RatingStar
                            rating={data.gradeForAccommodation}
                            maxStars={data.maxGrade}
                        />
                    </div>
                    <div className="single-review__content-box-header-grade d-flex justify-content-center align-items-center flex-column">
                        <p>{data.gradeForProvider}</p>
                        <RatingStar
                            rating={data.gradeForProvider}
                            maxStars={data.maxGrade}
                        />
                    </div>
                </div>
            </div>
            <div className="single-review__content-box-header-date-wrap d-flex justify-content-between">
                <p className="single-review__content-box-header-date">{data.reviewDate}</p>
                <div className="single-review__content-box-header-date-unit-box">
                    <p className="single-review__content-box-header-date-unit">{data.reviewedUnitTitle}</p>
                </div>
            </div>
            <div className="single-review__content-box-txt-wrap">
                <p
                    className="single-review__content-box-txt"
                    dangerouslySetInnerHTML={{ __html: showOriginal ? data.originalReviewContent : data.translatedReviewContent }}
                />
            </div>
            {translateControl && (
                <button
                    className="single-review__translate-btn"
                    onClick={handleToggle}
                    type="button"
                >
                    {showOriginal ? data.translatedCommentTitle : data.originalCommentTitle}
                </button>
            )}
            {replyControl && data.reviewReply && (
                <div className="single-review__reply d-flex flex-column">
                    <div>
                        <p className="single-review__reply-header-title">{data.reviewReply.author}</p>
                        <span className="single-review__reply-header-info">{data.reviewReply.replyDate}</span>
                    </div>
                    <p
                        className="single-review__reply-txt"
                        dangerouslySetInnerHTML={{ __html: showOriginalReply ? data.reviewReply.originalReviewContent : data.reviewReply.translatedReviewContent }}
                    />
                    {translateControl && (
                        <button
                            className="single-review__translate-btn"
                            onClick={handleToggleReply}
                            type="button"
                        >
                            {showOriginalReply ? data.reviewReply.translatedCommentTitle : data.reviewReply.originalCommentTitle}
                        </button>
                    )}
                </div>
            )}
        </div>
    );
}

export default SingleReview;
